module.exports = __webpack_public_path__ + "static/img/registered.ac4a8e2a.png";